import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy URL — redirects to the canonical schedule page with shop selected.
 */
export function LocationSchedulePage() {
  const { locationId = "" } = useParams<{ locationId: string }>();
  if (!locationId) {
    return <Navigate to="/app/schedule" replace />;
  }
  return (
    <Navigate
      to={`/app/schedule?locationId=${encodeURIComponent(locationId)}`}
      replace
    />
  );
}
